// extracted by mini-css-extract-plugin
module.exports = {"myPlayer":"Player_myPlayer__fb1_B"};